/**
 * Used in ProductCatalogue and Mambu
 */
export enum ZeefiProductTypes {
  SNP = 'NimSNPL',
  PAS = 'NimPAS',
  ZAS = 'NimZAS',
  ZNP = 'NimZNPL',
  ZNT = 'NimZNT'
}
